/* @flow strict */

import * as React from 'react';

type PropsType = {
    referrals: []
};

const ReferralDetail = ({ referrals }: PropsType): React.Element<'div'> => {
    return (
        <>
            <div className='referral-detail'>
            <h4>We have sent an email  on your behalf to the emails below:</h4>
            <ul>
                {referrals.map((ref: any, i: number): any => (
                    <li key={i}>{ref.email}</li>
                ))}
            </ul>
            </div>
        </>
    );
};

export default ReferralDetail;
